/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */

$.fn.animateTeasers = function () {
  const localStorageKey = 'animatedTeasersClicked';
  const timeoutInMinutes = 10;
  const timeout = timeoutInMinutes * 60 * 1000;
  const localStorageData = localStorage.getItem(localStorageKey);
  const now = new Date().getTime();

  /* click action */
  $(this).find('.m-career-teas').on('click', function () {
    window.location.href = $(this).find('a.btn').attr('href');
  });

  $(this).on('click', function () {
    if (!$(this).hasClass('animated')) {
      $(this).addClass('animated');
      localStorage.setItem(localStorageKey, new Date());
    }
  });

  /* time out */
  if (localStorageData && (now - localStorageData) > timeout) {
    localStorage.removeItem(this.localStorageKey);
  }

  /* remove animation on re-visit */
  if (!localStorage.getItem(localStorageKey)) {
    $('.m-teaser--animation.animated').removeClass('animated');
  }
};

$('.m-teaser--animation').animateTeasers();
